import styled from 'styled-components';

import { atMinWidth } from '../../../atoms/breakpoints';
import { color } from '../../../atoms/colors';
import { spacing } from '../../../atoms/spacing';
import { font } from '../../../atoms/typography';

const backgroundColor = {
  'blue-800': color.blue[800],
  'midnight-25': color.midnight[25],
};

const textColor = {
  'blue-800': color.common.white,
  'midnight-25': color.darkBlue[1000],
};

const iconBackgroundColor = {
  'blue-800': { background: color.blue[200] },
  'midnight-25': { background: color.blue[800] },
};

const closeIconColor = {
  'blue-800': color.common.white,
  'midnight-25': color.darkBlue[500],
};

export const CtaTheme = {
  'blue-800': {
    primary: 'Outline - Dark',
    secondary: 'Outline Dark - Midnight',
  },
  'midnight-25': { primary: 'Filled - Dark', secondary: 'Outline - Dark' },
};

export const Bar = styled.div`
  position: fixed;
  top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  min-height: 56px;
  background-color: ${props => backgroundColor[props.theme]};
  z-index: 9999;
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;

  ${atMinWidth.md`
    flex-direction: row;
    justify-content: ${props =>
      props.alignment === 'centered' ? 'center' : 'space-between'};
    max-width: 830px;
  `}

  ${atMinWidth.xl`
    max-width: 1248px;
  `}
`;

export const Heading = styled.div`
  &,
  & * {
    ${font[('text', 'md', '400')]}
    line-height: 1.5;
    color: ${props => textColor[props.theme]};
  }

  & strong {
    font-weight: 500;
  }

  & a {
    text-decoration: underline;

    &:hover {
      color: ${props => textColor[props.theme]};
      text-decoration: underline;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};
  max-width: 90%;

  ${atMinWidth.md`
    max-width: 50%;
    flex-direction: row;
    align-items: center;
  `}

  ${atMinWidth.xl`
    max-width: 100%;
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: ${spacing[12]};
  border-radius: 10px;
  background-color: ${({ theme }) => iconBackgroundColor[theme].background};
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[18]};
  a {
    max-height: 48px;
    width: 100%;
  }
  ${atMinWidth.md`
    flex-direction: row;
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  padding: 0;
  border: none;

  &:hover {
    background-color: transparent;
  }

  svg {
    color: ${({ theme }) => closeIconColor[theme]};
  }

  ${atMinWidth.md`
    ${props => props.variant !== 'simple' && 'position: unset;'}
  `}
`;
